export default ['ACP_NG'];
